module.exports = function(bh) {
    bh.match('search', function(ctx, json) {
        ctx.tParam('PANEL_ID', ctx.generateId(), true);
    });
};
